export const Options = {
    body: {
        key: [],
        type: [],
        show: [],
        display: [],
        options: [],
        required: [],
        defValue: []
    },
    refs: {
        supports: '[support]'
    },
    list: {
        key: self => self.key
    }
};
